module.exports = __webpack_public_path__ + "assets/img/close-pop.d14b0017.svg";